export function setLandingMenuOpen(open: boolean): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (open) {
    root.dataset.landingMenuOpen = 'true';
  } else {
    delete root.dataset.landingMenuOpen;
  }
}
